import { render, staticRenderFns } from "./AccountManagement.vue?vue&type=template&id=a5475a16&scoped=true&"
import script from "./AccountManagement.vue?vue&type=script&lang=js&"
export * from "./AccountManagement.vue?vue&type=script&lang=js&"
import style0 from "./AccountManagement.vue?vue&type=style&index=0&id=a5475a16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5475a16",
  null
  
)

export default component.exports